<script setup>
import { useIns } from 'src/utils/v2_helper/common';

const app = useIns();
</script>
<template>
  <section class="service">
    <div class="service-tile">{{ $t('checkout.selectOrderType') }}</div>
    <span class="service-content">{{ $t('checkout.dineIn') }}</span>
  </section>
</template>
<style scoped lang="scss">
.m-tile {
  color: Black;
  font-weight: bold;
  font-size: 12px;
}
.service {
  padding: 16px;
  &-tile {
    @extend .m-tile;
    margin-bottom: 4px;
  }
}
</style>
